export interface SerializedItemFilters {
  search: string
  comments__isnull?: boolean
  platform?: string
  added_by?: string
  states?: string
  status?: string
  status__in?: string // support for new version
  new_not_used?: string
  keyword?: string
  keywords?: string[] | string
  exclude_keywords?: string
  platform_type?: string
  group_tag?: string
  include_failed_scrapes: boolean
  irrelevant?: boolean
  infringement_type?: string
  infringement_type__in?: string
  reporter_id?: string
  reporter__in?: string
  platform__in?: string
  platform__not_in?: string
  brand_id?: string
  member_id?: string
  team_id?: string
  url?: string
  url__in?: string
  url_search?: string[] | string
  sku__in?: string
  sku__startswith_any?: string
  sku_search?: string[] | string
  min_price?: string
  max_price?: string
  min_timestamp?: string
  max_timestamp?: string
  min_ntd_sent_at?: string
  max_ntd_sent_at?: string
  ntd_sent_at?: string
  min_removed_at?: string
  max_removed_at?: string
  removed_at?: string
  min_flagged_at?: string
  max_flagged_at?: string
  flagged_at?: string
  country?: string
  country_of_origin?: string
  country__in?: string
  region__in?: string
  task_group_id?: string
  cron_task_id?: string
  product_type?: string
  fields: string
  expand: string
  seller_id?: string
  saw_id?: string
  platform_only?: boolean
  saw_only?: boolean
  missing_price?: boolean
  assigned_to_me?: boolean
  omit?: string
  scrape_scheduled?: number
  ntd_sent?: boolean
  removed?: boolean
  cron_task_type?: number
  scrape_scheduled_complete?: boolean
  scrape_scheduled_error?: boolean
  ipr?: string
  brand__in?: string[]

  offset?: number | null | string
  page?: number | null
  page_size?: number
  ordering?: string
  // About Seller
  seller_country?: string
  seller_country_of_origin?: string
  seller_status?: string
  // Image similarity search
  similar_to_hash?: string
  // OCR text search
  ocr_text_search?: string
}

// ─── Include / exclude filter mode (CORE-2817) ───────────────────────────────
// A field in 'exclude' mode emits its `__not_in` param instead of its include
// param. The two are mutually exclusive by meaning: selecting brands B1+B2
// already yields only B1+B2, so additionally excluding B3 is a no-op.
export type FilterMode = 'include' | 'exclude'

export const DEFAULT_FILTER_MODE: FilterMode = 'include'
